import { Component, OnInit } from '@angular/core'

import { SidebarService } from '../services/sidebar.service'

@Component({
    selector: 'app-sidebar-toggler',
    templateUrl: './sidebar-toggler.component.html',
    styleUrls: ['./sidebar-toggler.component.scss'],
    standalone: false
})
export class SidebarTogglerComponent implements OnInit {
  constructor(public sidebarService: SidebarService) {}

  ngOnInit(): void {}
}
